import allCases from '../../fields/cases/allCases';

export const QUERY_GET_ALL_MM_CASES = /* GraphQL */ `
	query($limit: Float, $offset: Float, $filter: MietminderungCaseFilter, $notEqual: MietminderungCaseFilter) {
		getAllMietminderungCase(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
		) {
			items {
				${allCases}
			}
			total
		}
	}
`;
